(function(Flickity) {

  const drawer = document.querySelector('[data-drawer="drawer-cart"]');
  const accordionTrigger = drawer.querySelector('[data-accordion-trigger="accordion-cart-upsell"]');
  const accordionBody = drawer.querySelector('[data-accordion-body]');

  const CLOSED_UPSELL_ACCORDION_STORAGE_KEY = "CLOSED_UPSELL_ACCORDION_STORAGE_KEY";

  initUpsellAccordion();

  function initUpsellAccordion() {
    drawer.addEventListener('theme:drawer:open', function() {
      const userClosedAccordion = localStorage.getItem(CLOSED_UPSELL_ACCORDION_STORAGE_KEY);
      if (userClosedAccordion && JSON.parse(userClosedAccordion) === true) {
        accordionBody.style.removeProperty('display');
        accordionTrigger.classList.remove('accordion-is-open');
      }
    });

    accordionTrigger.addEventListener('click', function() {
      if (accordionTrigger.classList.contains('accordion-is-open')) {
        localStorage.setItem(CLOSED_UPSELL_ACCORDION_STORAGE_KEY, true);
      } else {
        localStorage.setItem(CLOSED_UPSELL_ACCORDION_STORAGE_KEY, false);
        // debounce
        setTimeout(() => {
          var carousel = accordionBody.querySelector('[data-cart-recommended]');
          var flkty = Flickity.data(carousel);
          flkty.resize();
        }, 200);
      }
    })
  }

})(themeVendor.Flickity);